import MerchantService from "./MerchantAPIService";



class RestaurantDetailService extends MerchantService
{
   update = async (shopi_id:any,{name, description, address_1,address_2,type, city, state, zip_code, country, geolocation, tags, mobile_no, website, operating_hours_desc, tmp, reservation_fee,facebook,instagram, preparation_time}:any, imageList: any, deletedImage: any, locationID: any="") => {
      const result = await this.put({name, description, address_1,address_2, city, state, zip_code, country,geolocation,tags, mobile_no, website, operating_hours_desc, tmp, reservation_fee,facebook,instagram, imageList, deletedImage, type, preparation_time, locationID}, 'stores/'+shopi_id);
        
      return result ? result.data : null;
   }

   upload = () => {
      return this.baseURL + '/s3/upload?tmp=';
   }

   editImages = async (id: string, { images, file }: any) => {
      const result = await this.put({ images, file }, 'stores/' + id + '/images');
      return result ? result.data : null;
   }
   
   getAsapStatus = async () => {
      const result = await this.get('stores/getAsapStatus');
      return result ? result.data : null;
   }  

   editAsapStatus = async (status: boolean, id:string) => {
      const result = await this.put({status},'stores/getAsapStatus/' +id);
      return result ? result.data : null;
   }  

   getStoreSlug = async (slug:any) => {
      const result = await this.get('stores/getSlug/'+slug);
      return result ? result.data : null;
   }

}

export default RestaurantDetailService